var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareRectangle = function SvgShareRectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#031F39",
    viewBox: "0 0 23 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.75.25a4.5 4.5 0 0 0-4.5 4.5v13.5a4.5 4.5 0 0 0 4.5 4.5h13.5a4.5 4.5 0 0 0 4.5-4.5V4.75a4.5 4.5 0 0 0-4.5-4.5zm8.343 6.048a.844.844 0 1 0-.936 1.404l1.38.92c-1.525.272-2.98.805-4.193 1.614C7.463 11.49 6.156 13.423 6.156 16a.844.844 0 0 0 1.688 0c0-1.923.943-3.365 2.436-4.36 1.121-.748 2.547-1.234 4.071-1.437l-1.303 1.954a.844.844 0 1 0 1.404.936l2.25-3.375a.844.844 0 0 0-.234-1.17z",
    clipRule: "evenodd"
  })));
};
export default SvgShareRectangle;